
import { Component, Vue, Prop } from 'vue-property-decorator';
import { getMaxlengthValidationRule } from '@/helpers/validationRules';

@Component({})
export default class RoomLevelUnitTextField extends Vue {
  @Prop(String) public value: string;
  @Prop(Boolean) public loading: boolean;
  @Prop(Boolean) public disabled: boolean;

  get fieldValue() {
    return this.value;
  }

  set fieldValue(value) {
    this.$emit('input', value || '');
  }

  public maxlength = 30;
  public fieldValidationRules = [getMaxlengthValidationRule(this.maxlength)];
}
